import { render, staticRenderFns } from "./SelectExtendedNum.vue?vue&type=template&id=2bfdba0c&"
import script from "./SelectExtendedNum.vue?vue&type=script&lang=js&"
export * from "./SelectExtendedNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports